// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"qr_a","PostMenu__item--moderator":"qr_b","PostMenu__item--author":"qr_c"};